import { render } from "./PcIndexTable.vue?vue&type=template&id=77f71eb8"
import script from "./PcIndexTable.vue?vue&type=script&lang=js"
export * from "./PcIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__